import React, { useEffect, useState } from 'react'
import * as styles from "./styles/imagezoom.module.css";
import { Button, Icon, Modal } from 'semantic-ui-react';

const ImageZoom = ({ imageSource, header, openZoomModal, handleClose, children }) => {
    const [zoomLevel, setZoomLevel] = useState(1);

    useEffect(() => {
        setZoomLevel(1)
    }, [openZoomModal])

    return (
        <div className={`${styles.imageZoom}`}>
            <Modal
                size='fullscreen'
                open={openZoomModal}
                closeIcon
                onClose={() => handleClose()}
                className={`${styles.imageZoomModal} ${styles.imageZoomContainer}`}
            >
                <Modal.Header>{header}</Modal.Header>
                <Modal.Content
                    className={styles.imageZoomModalContent}
                >
                    <img
                        src={imageSource}
                        alt={header}
                        className={styles.imageZoomModalImage}
                        style={
                            { width: `calc(${zoomLevel} * 100%)`, height: `calc(${zoomLevel} * 100%)`}
                        }
                    />
                </Modal.Content>
                <div className={styles.imageZoomModalFooter}>
                    <div className={styles.imageZoomCarouselContainer}>
                        {children}
                    </div>
                    <div className={styles.imageZoomModalControls}>
                        <Button 
                            size="massive"
                            icon
                            disabled={zoomLevel === 1} 
                            onClick={() => {
                                if (zoomLevel > 1) setZoomLevel(zoomLevel - 0.25);
                            }}
                        >
                            <Icon name='zoom-out' />
                        </Button>
                        <Button 
                            size="massive"
                            icon
                            disabled={zoomLevel === 3} 
                            onClick={() => {
                                if (zoomLevel < 3) setZoomLevel(zoomLevel + 0.25);
                            }}
                        >
                            <Icon name='zoom-in' />
                        </Button>
                    </div>
                </div>
            </Modal>
        </div>
    )
}

export default ImageZoom